import { render, staticRenderFns } from "./OutgoingDocumentAttachmentDetailUpload.vue?vue&type=template&id=4ee96e1a"
import script from "./OutgoingDocumentAttachmentDetailUpload.vue?vue&type=script&lang=js"
export * from "./OutgoingDocumentAttachmentDetailUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports